import React from 'react';
import { Row, Col, Form, Button, Collapse, Card } from 'react-bootstrap';
import { FaFilter, FaTimes } from 'react-icons/fa';

const TableFilter = ({ show, onHide, filters, onFilterChange, onClear, filterOptions = [] }) => {
    return (
        <Collapse in={show}>
            <div className="p-3 bg-light border-bottom">
                <Row className="g-3">
                    {filterOptions.map((option, index) => (
                        <Col key={index} md={option.col || 3}>
                            <Form.Group>
                                <Form.Label className="x-small fw-bold text-uppercase text-muted mb-1">
                                    {option.label}
                                </Form.Label>
                                {option.type === 'select' ? (
                                    <Form.Select
                                        name={option.name}
                                        value={filters[option.name] || ''}
                                        onChange={onFilterChange}
                                        size="sm"
                                        className="border-0 shadow-sm"
                                    >
                                        <option value="">All {option.label}</option>
                                        {option.options.map((opt, i) => (
                                            <option key={i} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </Form.Select>
                                ) : (
                                    <Form.Control
                                        type={option.type || 'text'}
                                        name={option.name}
                                        value={filters[option.name] || ''}
                                        onChange={onFilterChange}
                                        placeholder={option.placeholder}
                                        size="sm"
                                        className="border-0 shadow-sm"
                                    />
                                )}
                            </Form.Group>
                        </Col>
                    ))}
                    <Col md={2} className="d-flex align-items-end gap-2">
                        <Button variant="outline-danger" size="sm" className="w-100" onClick={onClear}>
                            Reset
                        </Button>
                    </Col>
                </Row>
            </div>
        </Collapse>
    );
};

export default TableFilter;
